module.exports = __webpack_public_path__ + "static/media/stockhausen_cartagena_1.e5c5619b.jpg";